import { PageConfigMap } from '@/entities/page-config-map';
import { PageUrlKey } from '@/entities/page-url-key';

export function getNavItemName(pageKey: PageUrlKey): string {
  const config = PageConfigMap[pageKey];
  return config.nameShort || config.nameFull;
}
